/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for util
export { Class } from './util/decorators';
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-google-login/~/@angular/core/src/util.js
// module id = 1387
// module chunks = 21